var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAftereffects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "14.88,28 21.72,28 18.24,16.64  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.76,23.14c-0.88-0.6-1.907-0.899-3.08-0.899c-1.174,0-2.167,0.359-2.98,1.08c-0.814,0.72-1.22,1.773-1.22,3.16v3.199 l8.6-0.439v-3.08C41.08,24.747,40.64,23.74,39.76,23.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.824,0H12.176C5.462,0,0,5.462,0,12.176v29.648C0,48.538,5.462,54,12.176,54h29.648C48.538,54,54,48.538,54,41.824 V12.176C54,5.462,48.538,0,41.824,0z M25.2,40l-2.76-9.04h-8.32L11.48,40H8.36l8.24-28h3.32l8.52,28H25.2z M44,31.8L32.48,32.4 v2.08c0,2.267,1.333,3.399,4,3.399c1.653,0,3.466-0.546,5.44-1.64L43,38.6c-2.054,1.254-4.2,1.881-6.44,1.881 c-4.64,0-6.96-1.946-6.96-5.841V26.44c0-2.16,0.673-3.841,2.02-5.04c1.346-1.2,3.126-1.801,5.34-1.801s3.94,0.594,5.18,1.78 c1.24,1.187,1.86,2.834,1.86,4.94V31.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAftereffects);
export default __webpack_public_path__ + "static/media/aftereffects.84fc5dcec4345571f1c6a6f7ce2c9151.svg";
export { ForwardRef as ReactComponent };